import { SET_APP_DATE_FILTER, SetAppDateFilterAction } from "./AppTypes";
import { dateFilterStorage, isValidDateFilter } from "../utils/dateFilterStorage";

const initialState = dateFilterStorage.get() || null;

export default function dateFilterReducer(
  state = initialState,
  action: SetAppDateFilterAction
): string | null | undefined {
  switch (action.type) {
    case SET_APP_DATE_FILTER: {
      if (!action.dateFilter) {
        dateFilterStorage.remove();
        return undefined;
      }
      if (!isValidDateFilter(action.dateFilter)) {
        return state;
      }
      dateFilterStorage.set(action.dateFilter);
      return action.dateFilter;
    }
    default:
      return state;
  }
}
